import { leaveNewsRoute } from '../state/news-route';
import { pendingAnchor } from '../state/pending-anchor';

/**
 * Shared by `SiteHeader` and `SiteFooter`, both of which are mounted on the
 * landing page *and* on the news pages — one nav link has to mean two
 * different things depending on where it is clicked from: an in-page scroll
 * on the landing page, or "go there, then scroll" from anywhere else.
 *
 * `#top` — `LandingScreen`'s own `<main id="top">` — is what tells the two
 * cases apart, since only the landing page renders it.
 */
export function goToSiteSection(href: string): void {
  const onLandingPage = document.getElementById('top') !== null;
  if (!onLandingPage) {
    pendingAnchor.value = href;
    leaveNewsRoute();
    return;
  }
  if (href === '#top') {
    document.querySelector('.landing')?.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }
  document.querySelector(href)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
